import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogAPI, authAPI } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { useLanguage } from '../../context/LanguageContext';
import { LoadingPage } from '../../components/Loading';
import './Member.css';

const Dashboard = () => {
  const { error: toastError } = useToast();
  const { t, formatDate } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);
  const [recentPosts, setRecentPosts] = useState([]);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [profileRes, postsRes] = await Promise.all([
        authAPI.getProfile(),
        blogAPI.getLatest(),
      ]);

      setProfile(profileRes.data);
      const posts = Array.isArray(postsRes.data) ? postsRes.data : postsRes.data?.results || [];
      setRecentPosts(posts.slice(0, 5));
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
      toastError('載入儀表板資料失敗');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  if (loading) {
    return <LoadingPage message="加載中..." />;
  }

  const memberProfile = profile?.profile;

  return (
    <div className="member-page">
      <h1 className="dashboard-title">{t('member.dash')}</h1>

      <div className="dashboard-top-grid">
        <div className="member-card quick-access-top">
          <h2>{t('member.quick')}</h2>
          <div className="quick-actions">
            <Link to="/member/qr-code" className="action-button">
              <span className="action-icon">🔖</span>
              <span>{t('nav.myQr')}</span>
            </Link>
            <Link to="/member/profile" className="action-button">
              <span className="action-icon">👤</span>
              <span>{t('nav.profile')}</span>
            </Link>
            <Link to="/blog" className="action-button">
              <span className="action-icon">📝</span>
              <span>{t('nav.news')}</span>
            </Link>
            <Link to="/member/change-password" className="action-button">
              <span className="action-icon">🔒</span>
              <span>{t('nav.password')}</span>
            </Link>
          </div>
        </div>

        <div className="welcome-section member-card">
          <h2>{t('member.welcome', { name: memberProfile?.chinese_name || profile?.phone_number })}</h2>
          <div className="member-info-row">
            <div className="info-item">
              <span className="info-label">{t('member.number')}</span>
              <span className="info-value">{memberProfile?.member_number || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">{t('member.joined')}</span>
              <span className="info-value">
                {memberProfile?.membership_date
                  ? formatDate(memberProfile.membership_date, { year: 'numeric', month: 'long', day: 'numeric' })
                  : memberProfile?.created_at
                    ? formatDate(memberProfile.created_at, { year: 'numeric', month: 'long', day: 'numeric' })
                    : 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="member-card">
        <div className="section-header">
          <h2>{t('member.news')}</h2>
          <Link to="/blog" className="view-all-link">{t('member.viewAll')}</Link>
        </div>

        {recentPosts.length > 0 ? (
          <div className="registrations-list">
            {recentPosts.map((post) => (
              <div key={post.id} className="registration-item">
                <div className="registration-info">
                  <h3>{post.title}</h3>
                  {post.published_date && (
                    <p className="event-date">
                      📅 {formatDate(post.published_date, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </p>
                  )}
                  {post.summary && <p>{post.summary}</p>}
                </div>
                <Link to={`/blog/${post.id}`} className="btn btn-outline">
                  {t('member.read')}
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">{t('member.noNews')}</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
